import React, { useState } from 'react'
import { Avatar, Button, Col, Form, Input, Modal, Row, Table } from 'antd'
import { getAllHeroes } from '../../../modules/hero'
import { useDispatch, useSelector } from 'react-redux'
import { HeroType } from '../../../config'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../../utils/hooks'

const initialOptions = {
  page: 0,
  size: 20,
  keyword: ''
}

const BrandHeroForm = (props) => {
  const dispatch = useDispatch()
  const { visible, onOk, onCancel, form } = props
  const { getFieldDecorator, validateFields } = form
  const [filterOption, setFilterOption] = useState(initialOptions)
  const { heroList } = useSelector(
    (state) => ({
      heroList: state.hero.heroList
    }),
    []
  )

  async function fetch() {
    await dispatch(getAllHeroes(filterOption))
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  function onClick(e, record) {
    onOk(record.heroDtoList.id)
  }

  async function onClear() {
    filterOption.page = 0
    filterOption.size = 20
    filterOption.keyword = ''
    await dispatch(getAllHeroes(filterOption))
  }

  const columns = [
    {
      title: 'Avatar',
      dataIndex: 'heroDtoList.imageUrl',
      key: 'imageUrl',
      render: (text, record) => (
        <div>
          <Avatar src={text} />
        </div>
      )
    },
    {
      title: 'Email',
      dataIndex: 'heroDtoList.email',
      key: 'email'
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroDtoList.heroType',
      key: 'heroType',
      render: (name, row) => <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
    },
    {
      title: 'Circular Hero Name',
      dataIndex: 'heroDtoList.name',
      key: 'name'
    },
    {
      title: 'Telephone',
      dataIndex: 'heroDtoList.tel',
      key: 'telephone'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            onClick={(e) => onClick(e, record)}>
            เลือก
          </Button>
        </span>
      )
    }
  ]

  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllHeroes(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        filterOption.keyword = '%' + values.keyword + '%'
        await dispatch(getAllHeroes(filterOption))
      }
    })
  }

  return (
    <Modal
      width={1000}
      title={`Add Hero`}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Form name="formBrandHero" onSubmit={onSubmit} layout="vertical">
        <Row gutter={8} justify="end" type="flex">
          <Col span={20}>
            <Form.Item>
              {getFieldDecorator(`keyword`)(
                <Input placeholder="Search from Hero Name, Hero Tel, Email" />
              )}
            </Form.Item>
          </Col>
          <Col span={4}>
            <Row type="flex" gutter={8}>
              <Col>
                <Button type="primary" htmlType="submit">
                  ค้นหา
                </Button>
              </Col>
              <Col>
                <Button onClick={() => onClear()}>เคลียร์</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <Table
        rowKey={(record) => record.id}
        dataSource={heroList.content}
        columns={columns}
        pagination={{
          current: !isEmpty(heroList) ? heroList.pageable.pageNumber + 1 : 0,
          pageSize: heroList.size,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          onChange: onChange,
          total: heroList.totalElements
        }}
      />
    </Modal>
  )
}

const WrappedBrandHeroForm = Form.create({ name: 'BrandHeroForm' })(
  BrandHeroForm
)
export default WrappedBrandHeroForm



// WEBPACK FOOTER //
// ./src/pages/BrandHero/BrandHeroForm/index.js